import { useState } from "react";
import { Link } from "react-scroll";

/*--------------------
* Proejct Section
----------------------*/

function Proejct(props) {
    return (
        <>
            <div className="px-modal mfp-hide">
                <div className="single-project-box">
                    <div className="grid grid-cols-12 gx-3">
                        <div className="col-span-12 md:col-span-7 mb-10 md:mb-0">
                            <div className="grid grid-cols-2 gap-2">
                                {props.projectDetails.images.map((img, i) => {
                                    return ( 
                                        <div key={`image_${i}`} className="col-span-1">
                                            <img className="border" src={img} title="" alt="" />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-5 md:pl-10 lg:pl-14">
                            <h4 className="font-[600] text-[25px] text-black mb-4 pb-4 border-b">{props.projectDetails.title}</h4>
                            <p className="mb-3">{props.projectDetails.description}</p>
                            <p>{props.projectDetails.subDescription}</p>
                            <ul className="m-0 p-0 pt-7 list-none">
                                {props.projectDetails.details.map((detail, i) => {
                                    return (
                                        <li key={`detail_${i}`} className="flex py-2">
                                            <span className="w-[100px] font-[600] text-black">{detail.title}:</span>
                                            <span>{detail.description}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                        <button className="px-close" onClick={ props.closePopup }><i className="fa fa-times"></i></button>
                    </div>
                </div>
            </div>
        </>
    );
}


/*--------------------
* Work Section
----------------------*/

export default function Work() {
    const [showModal, setShowModal] = useState(0);
    const closePopup = () => {
        setShowModal(0);
    }

    const projectDetails = [
        {
            title: 'Be Stronger Website',	
            description: 'Be Stronger es un Centro que combina servicios de rehabilitación física, entrenamiento y acondicimiento, que por sus necesidades únicas no encontraban un sistema adecuado a su estilo de trabajo súper personalizado, en conjunto con su visión y conociendo a detalle su sistema SSI, logramos crear la plataforma perfecta para su comunidad',
            subDescription: '',
            images: ['img/bs_1.webp', 'img/bs_2.webp', 'img/bs_3.webp', 'img/bs_4_1.webp'],
            details: [
                {
                    title: 'Tipo',
                    description: 'WebApp',
                },
                {
                    title: 'Tecnologías',
                    description: 'React, Next, HTML, CSS, JS, Python/Django, PostgreSQL, Docker, AWS',
                },
                {
                    title: 'País ',
                    description: 'México',
                },
                {
                    title: 'Dirección URL',
                    description: 'www.bestronger.mx',
                },
            ]
        },
        {
            title: 'Webapp Musicalerias',
            description: 'Sistema de gestión escolar para Musicalerías, empresa con 20 años de trayectoria en la enseñanza de la música y el mundo del espectáculo. ',
            subDescription: 'Gestión de mensualiadades, asistencia de alumnos, calendario de clases, recordatorios de pagos, material didático para apoyo de clases, reportes mensuales y mucho más.',
            images: ['img/MSC_1.WEBP', 'img/MSC_2.WEBP', 'img/MSC_3.WEBP', 'img/MSC_4.WEBP'],
            details: [
                {
                    title: 'Tipo',
                    description: 'Website',
                },
                {
                    title: 'Tecnologías',
                    description: 'React, Next, HTML, CSS, JS, Python/Django, PostgreSQL, Docker, AWS',
                },
                {
                    title: 'País ',
                    description: 'México',
                },
                {
                    title: 'Dirección URL',
                    description: 'https://www.musicaleriasacademia.com/',
                },
            ]
        },
        {
            title: 'Sitio Web Informativo de Mundatus, agencia de limpieza y desinfección',
            description: 'Sitio Web en desarrollo con optimización SEO para potenciar sus ventas. ',
            subDescription: 'Mundatus es una empresa tapatía dedicada a la limpieza y desinfección de calidad, con maquinas de inyección succión para colchones, alfombras, salas, sillas, oficinas, clínicas, restaurantes, negocios, hoteles y más.',
            images: ['img/mundatus_1.webp', 'img/mundatus_2.webp', 'img/mundatus_3.webp', 'img/mundatus_4.webp'],
            details: [
                {
                    title: 'Tipo',
                    description: 'Website',
                },
                {
                    title: 'Tecnologías',
                    description: 'React, Next, HTML, CSS, JS, Tailwind',
                },
                {
                    title: 'País ',
                    description: 'México',
                },
                {
                    title: 'Dirección URL',
                    description: 'https://mundatus-demo.netlify.app/',
                },
            ]
        },
        {
            title: 'Variedad de Sitios Web',
            description: 'E-commerce, Sitios Informativos, Sitios de agenda... en fin; soluciones web personalizadas.',
            subDescription: 'Desarrollamos desde un sitio web informativo, hasta uno completo con e-commerce, agenda, blog, servicios de mensajeria vía WhatsApp, con IA incorporada, mapas, redes sociales, etc.',
            images: ['img/extra_1.webp', 'img/extra_2.webp', 'img/extra3.webp', 'img/extra_4.webp'],
            details: [
                {
                    title: 'Tipo',
                    description: 'Website',
                },
                {
                    title: 'Tecnologías',
                    description: 'React, Next, HTML, CSS, JS, Tailwind, Python/Django, PostgreSQL, Docker, AWS',
                },
                {
                    title: 'País ',
                    description: 'México',
                },
                {
                    title: 'Dirección  URL  ',
                    description: 'aim-clinic-demo.netlify.app, https://mujeralada.netlify.app/es, https://encoremusica.mx/, https://https://thestrengthapparel.com.mx//',
                },
            ]
        },
    ]
    return (
        <>
            <section data-scroll-data="3" id="portfolio" className="section bg-orange-50">
                <div className="container">
                    <div className="grid section-heading">
                        <div className="lg:col-span-6 text-center mx-auto">
                            <h3><span>Algunos Proyectos</span></h3>
                        </div>
                    </div>
                    <div className="lightbox-gallery portfolio-box">`
                        <div className="grid grid-cols-12 gx-3 mb-5 pb-lg-3 mb-lg-3 pb-12 portfolio-box justify-around items-center">
                            <div className="col-span-12 md:col-span-6 md:px-5 lg:px-10 mb-10 md:mb-0">
                                <div className="portfolio-img">
                                    <img src="img/bs_cover_1.webp" title="Wellness webapp" alt="strong men in a gym" />
                                    <Link to="#" className="gallery-link gallery-link-icon">
                                        <i className="fas fa-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-6 md:px-5 lg:px-10">
                                <div className="portfolio-text">
                                    <h6><span>Web App</span></h6>
                                    <h4>Web app desarrollada para centro de Desarrollo Humano</h4>
                                    <p>Incluye las funciones de agenda de citas, calendario, recordatorios y notificaciones. Además integra un sistema de rútinas personalizadas, capaces de ser editadas por el Coach y visualizadas por los usuarios para su óptimo segumiento. Incluye asimismo un sistema de pagos con tarjeta de crédito o medio físico para el area administrativa.</p>
                                    <div className="btn-bar">
                                        <div className="px-btn px-btn-theme px_modal" onClick={() => setShowModal(1)}>Ver Proyecto </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gx-3 mb-5 pb-lg-3 mb-lg-3 pb-12 portfolio-box justify-around items-center">
                            <div className="col-span-12 md:col-span-6 md:px-5 lg:px-10 md:order-last mb-10 md:mb-0">
                                <div className="portfolio-img">
                                    <img src="img/home_msc.webp" title="Musicalerias webapp home page" alt="docente y alumno tomando clases de guitarra" />
                                    <Link to="#" className="gallery-link gallery-link-icon">
                                        <i className="fas fa-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-6 md:px-5 lg:px-10">
                                <div className="portfolio-text">
                                    <h6><span>Web App</span></h6>
                                    <h4>Web App desarrollada para Musicalerías, escuela de música</h4>
                                    <p>Incluye funciones como control de agenda de clases, calendario, recordatorios y notificaciones. Además integra un sistema de segumiento de alumnos personalizado, capaz de ser editado por el Docente y visualizado por el alumno para su óptimo seguimiento. Incluye asimismo un sistema de pagos con tarjeta de crédito o medio físico para el area administrativa. </p>
                                    <div className="btn-bar">
                                        <div className="px-btn px-btn-theme px_modal" onClick={() => setShowModal(2)}>Ver Proyecto </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gx-3 mb-5 pb-lg-3 mb-lg-3 pb-12 portfolio-box justify-around items-center">
                            <div className="col-span-12 md:col-span-6 md:px-5 lg:px-10 mb-10 md:mb-0">
                                <div className="portfolio-img">
                                    <img src="img/mundatus_portada.webp" title="" alt="" />
                                    <Link to="#" className="gallery-link gallery-link-icon">
                                        <i className="fas fa-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-6 md:px-5 lg:px-10">
                                <div className="portfolio-text">
                                    <h6><span>Sitio Web Informativo (en desarrollo) </span></h6>
                                    <h4>Mundatus, soluciones integrales de desinfección y limpieza </h4>
                                    <p>Sitio Web en desarrollo con optimización SEO para potenciar sus ventas. Mundatus es una empresa tapatía dedicada a la limpieza y desinfección de calidad, con maquinas de inyección succión para colchones, alfombras, salas, sillas, oficinas, clínicas, restaurantes, negocios, hoteles y más. </p>
                                    <div className="btn-bar">
                                        <div className="px-btn px-btn-theme px_modal" onClick={() => setShowModal(3)}>Ver Proyecto </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gx-3 mb-5 pb-lg-3 mb-lg-3 pb-12 portfolio-box justify-around items-center">
                            <div className="col-span-12 md:col-span-6 md:px-5 lg:px-10 md:order-last mb-10 md:mb-0">
                                <div className="portfolio-img">
                                    <img src="img/extra_portada1.webp" title="sitio web informativo de una banda de musica" alt="banda de musica en escenario cantando y tocando diversos instrumentos" />
                                    <Link to="#" className="gallery-link gallery-link-icon">
                                        <i className="fas fa-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-6 md:px-5 lg:px-10">
                                <div className="portfolio-text">
                                    <h6><span>Diseño Web</span></h6>
                                    <h4>Algunos otros sitios desarrollados</h4>
                                    <p>E-commerce, Sitios Informativos, Sitios de agenda... en fin; soluciones web personalizadas.</p>
                                    <div className="btn-bar">
                                        <div className="px-btn px-btn-theme px_modal" onClick={() => setShowModal(4)}>Ver Proyectos</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showModal ? (
                <>
                    <Proejct closePopup={closePopup} projectDetails={projectDetails[showModal - 1]}></Proejct>
                </>
            ): null}
        </>
     );
}
